import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function PromiseSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-charcoal-dark relative border-y border-white/5 overflow-hidden" data-id="element-198">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(212,168,83,0.05)_0%,transparent_50%)]" data-id="element-199" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-200">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-201">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight" data-id="element-202">
            De no saber por dónde empezar… <br data-id="element-203" />
            <span className="text-gold italic font-normal" data-id="element-204">
              a vender en 30 días
            </span>
          </h2>

          <p className="text-xl sm:text-2xl text-cream-muted font-light mb-12 max-w-2xl mx-auto" data-id="element-205">
            Un sistema simple, probado y real para generar ingresos desde tu
            cocina.
          </p>

          <motion.a href="https://lacocinaquevende.shop/cart/53378602205457:1" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="group relative inline-flex items-center justify-center gap-3 px-8 py-4 text-lg font-bold text-charcoal bg-gold hover:bg-gold-light rounded-full overflow-hidden transition-all duration-300 shadow-[0_0_40px_rgba(212,168,83,0.3)] hover:shadow-[0_0_60px_rgba(212,168,83,0.5)]" data-id="element-206">
            <span className="relative z-10 flex items-center gap-2" data-id="element-207">
              QUIERO EMPEZAR HOY
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-208" />
            </span>
            <div className="absolute inset-0 h-full w-full bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" data-id="element-209" />
          </motion.a>
        </motion.div>
      </div>
    </section>;
}